import { getGraphQLClient, GET_AI_PROMPT_LOGS } from '../lib/graphql';

interface AiPromptLog {
  durationMs?: number;
}

interface AiPromptLogsResponse {
  aiPromptLogs?: AiPromptLog[];
}

interface GetAIEstimatedDurationMsParams {
  requestType: string;
  limit?: number;
  buffer?: number;
}

// Returns a promise that resolves to the median duration (ms) of the last N logs for a given requestType/jobType, plus a buffer
export async function getAIEstimatedDurationMs({ requestType, limit = 50, buffer = 0.2 }: GetAIEstimatedDurationMsParams): Promise<number | null> {
  try {
    const client = getGraphQLClient();
    const data = await client.request<AiPromptLogsResponse>(GET_AI_PROMPT_LOGS, {
      requestType,
      limit,
      offset: 0,
      success: true,
    });
    const logs = data?.aiPromptLogs || [];
    if (!logs.length) return null;
    const durations = logs
      .map((log: AiPromptLog) => log.durationMs)
      .filter((d): d is number => typeof d === 'number' && d > 0)
      .sort((a: number, b: number) => a - b);
    if (!durations.length) return null;
    const mid = Math.floor(durations.length / 2);
    const median = durations.length % 2 !== 0 ? durations[mid] : (durations[mid - 1] + durations[mid]) / 2;
    return Math.round(median * (1 + buffer));
  } catch {
    return null;
  }
}
